import { type Deal } from './types'

export enum CustomFields {
  PROMISE_TO_PAY_DATE = 'dc56349925a7bc36679b25fcce6e360d61360966',
  BOOKING_ID = '125c4fce0207df8c4705d6ac34f603a76695c9fa', // PLT Booking ID
  FULL_PAYMENT_MADE = '083fdfd6b70a34f90369d41fbf485c56f665a6a6',
  STRIPE_SUBSCRIPTION_CANCELLED = 'c93a36ecfb97775597fbb26bc4243259198aea4e', // 2. Stripe: Subscription Canx AND Past due invoices void",
  TICKET_STATUS = '3587cc05915b664a5c963a4d37fb69fc0093591f',
  CANCELATION_PENALTY = '7966eb05d61dddc4ca14af358387a7252bbb9630',
  NON_REFUNDABLE_TAXES = '3503ad5361080074917ec9dcbb7a2f5df7012da5',
  BASE_FARE = 'eeae2ee1b91b0663e0c9ba3e98c01713984f60a8',
  PNR = 'c7d77c4f453cb5b2cfdbebc87ac6053fefabeb6c',
  NDC_ORDER_ID = '2c5e0b02f2bb3f9a0c97a805ee05b2d1fefe651f',
  TICKET_SUPPLIER = 'd268422f0b14adc829a9f1aa8f56d982a9b8425f',
  INVOICE_DATE = 'b2fb25f5aa374b1571ea1a31d29fd2d1ad6b6fc5',
  CONTACT_DETAILS_UPDATED_AT_FULL_PAYMENT = 'f195ee16cfafe1009306b2cb10b63a489d4da544',

  // ==== Personal Info ====
  EMAIL = '0bfec7c4da5a77f2ec916bb0861e4052b36d59d0',
  MOBILE_NUMBER = '3a5c8e8ffc80dade16bac60df9f603bfdf22216b',

  // ==== Fintech Info
  INSTALMENT_START_DATE = '5d6f08b2b02767eb1c29eb6ad6d1d76c4df2d603',
  INSTALMENT_END_DATE = 'ae38765c5a716eac770b4acdbb19f60988c9c4cc',
  INSTALMENT_AMOUNT = '91476094a797c04f9ecdb546f28a90fcb884be15',
  INSTALMENT_FREQUENCY = '72096d781c5ab3d64cd0861dfa2316b753fef6c1',
  INSTALMENTS_NUMBER = '6de04bcde547a77a62c42503cb920daa2dc5bde9',
  PAYMENT_METHOD = '5f85635185abdb21370611dd5b88ca9cedd6bba9',
  FINANCIAL_COMPENSATION = '9c4aefb91a81772ab01511a3787daea38ac98f4a',
  AIRLINE_COMMISSION = '333ec3a5711353b93b0178bb9b0460eb8239d9ce',

  // ==== Travel Details Fields ====
  ORIGIN = '5f36fc07043d00af9dd499c6b5c189fc181b5342',
  DESTINATION = 'f579d77913a0b62d0f724d237038a3aa883fa754',
  DEPARTURE_AIRLINE = '9424de5a3043228de9a203a64bfed5f4abc42f9d',
  DEPARTURE_DATE = 'c379854231199106395b59da3936732ce6d53cfd',
  DEPARTURE_AL_TIME = '42674d823b466bcb852dad48d8b366bde46360dc',
  RETURN_AIRLINE = 'a7196f60d3dc74564629c4dbc682bdeeafd63371',
  RETURN_DATE = 'a3fb9c692335cb240628d4f9752a9a7ab8f0013b',
  RETURN_AL_TIME = '4d2874ee53d5d7774aa31256d7ff6c22f3f52fe1',
  TRAVELLERS_TOTAL = '16d9c51672a87eefefea59dc248626462ac311c9',
  ADULTS_TOTAL = '51b8016414703476d02361f33cbe3be392fb6974',
  INFANTS_TOTAL = 'f4b788aa6b05bb6d8431ef883ab22261a1c0162f',
  CHILDREN_TOTAL = '26cab7895b201eeb106ee13904a6cd03a0d59499',
  FARE_BASIS_CODES = '30accf628495f68257a772078777f62f5066ced1',
  CUSTOMER_OBSERVED_REFUNDABLE = '84d4681472436f93bfd3127638ffa538dd196cb3',
  ITINERARY_SENT = '8794adce4a9cc7d4927a985321986ae1d4535672',
  ITINERARY_SENT_DATE = '17adf1230b20338570d23ae16870b093d72a3d66',
  CABIN_BOOKED = 'dda3867b8b3eafdd27266be62fd283ce04d91a60',
  GROSS_FARE_COST = 'e5aae71a7519a6aa50a0f422beb50a6b409d96bd',
  NET_FARE_COST = 'ba8944fe23c99c1c53ded9ed09f10f089c4903dc',
  TICKETING_DATE = 'ab3367bb6f9a02df81c1188a5f8d05f7d9382238',
  AIRLINE_REFERENCE = 'c74b8b4254059f057f94adb72f1cf93a4104eb45',
  ETICKET_NUMBER = 'dedd67abc22153aaef10bf845aa922bac054928e',
  ETICKET_UPLOADED = '2be32ce7be47d452c2f622693eb5c77642cc6fb9',

  TICKET_ISSUED_DATETIME = '1d8856970fe3748deb9f2424eed74242d081883d',

  // ==== OPERATION Fields ====
  NEXT_REVIEW_DATE = 'aebfb6a40ae22be984a4d37b884fc08e5a87a031',

  // ==== Operation Fields NOT in deal response ====
  DF_FINAL_EMAIL_SENT = 'aeab5326c19177dd6ee3de71adc8d2f2125d7811',
  IMMINENT_CHECK_COMPLETED_DATE = 'bbabdadcdca03f1cb85a2ef2b0812e5536c41ccb',

  // Operation Fields for cancellation and refund
  XL_LAY_BY_TERMINATION_FEE = 'b1955786789026d5bd0940fb613ebdefc5660fcc',
  XL_CANCELLATION_DATE = 'f93f34d15f36847273b26b8a2357b44c65623771',
  XL_PARTIAL_BOOKING_CANCELLATION_DATE = '7c461635829c264791ef8af83774a7eff1dd17d5',
  XL_PARTIAL_BOOKING_ETICKET_NUMBERS = '4bce2a721d01cef121b467f4fac8df2967c7b9ee',
  XL_CUSTOMER_TOTAL_PAID_TO_DATE = 'dc66fa49aa30188fd4c74ed2d19ae8413acf235f',
  XL_STRIPE_SUBSCRIPTION_CANCELLED_AND_UNPAID_INVOICES_VOIDED = 'b8438ff23f3923458c390267ca4526dc525acc98',
  XL_CANCELLED_WITH_SUPPLIER_REQUESTED_REFUND = '588a065d637634f1ea4d788f9a4ff3d2442521b1',
  XL_FINAL_EMAIL_SENT_TO_CUSTOMER = 'dc9f15574efbc1d3f4d8eeb899b62446a4491aa2',
  CANCELLATION_REASON = 'b30cf54df78f5d18dc16a09c49d0fcaaab9f5449',
  RF_SUPPLIER_TOTAL_CASH_REFUND = 'e5a3c05b69f9aeffa9982ca3cf521bcab00f8652',
  RF_SUPPLIER_AMOUNT_RECEIVED = '31a52164e6da782a53b2472c993b091b99c5ba0e', // Amount Received from Supplier
  RF_SUPPLIER_REFUND_RECEIVED_DATE = 'f488be4d9ae55f72409216211d753d1d0af04ed1', // RF - Supplier: When did we get/receive the refund from supplier?
  RF_SUPPLIER_EXPECT_REFUND_BACK_DATE = '31101eaa215a2faf07424c601ace00cc096f3501',
  RF_CUSTOMER_ADVISED_REFUND_WOULD_BE_SENT_DATE = 'a82ee0da68502ae2ae1382342f50a61ae952cb1a',
  RF_AMOUNT_PROMISED_TO_CUSTOMER = '2539d868ecf7ffde2853df67fe0d36d32b4f2ba2',
  RF_RELEASE_TO_CUSTOMER_DATE = '7eb4f7edb6eafaa76bdc75f0bf0104dffa4fbf15',
  RF_REMITTANCE_SENT = '8faf7d1a1b8a795774efbc3076def88d1af264a9',
  FIRST_DISPUTE_RAISED_DATE = '912aa68d9b1ca0417f6713e75db1b3d0afb1357c',
  CANCELLED_BY = 'ae38ef1d25c67e084996892afb983abdf5e1b771',
  REFUNDED_BY = 'd26eefa75f2d07f1600e02e6bfe8a83b18844632',
  REFUND_LAST_CHASED_ON = 'ed34807ca1a35862a7e753b832c5631cfad4722c',
  REFUND_PROTECT_REFUND_DATE = '6938e8d675f39fd2a81d350799a48e879e22d53a', // Refund Protect: date the refund was received
  REFUND_PROTECT_AMOUNT_RECEIVED = '2e7353697a49a5a93c557fa435c22acd5b5d3dec', // Refund Protect: amount received (monetary)
  REFUND_PROTECT_POLICY_CHANGE_COST = '6909e9a0246659f34284e1ecab43c2e539d8c376', // Refund Protect: policy change cost (monetary)
  REFUND_PROTECT_GROSS_POLICY_VALUE = 'f2da18f54ac818748ba5162e52abdc11de131f62', // Refund Protect: gross policy value (monetary)
  PAYMENT_KIND = '69b76a2742f398df113c8c1cd1159cf4a9fbfe31', // Payment kind: Lay-by or In Full (single option)
  IN_FULL_PAYMENT_METHOD = 'd6897571d1dfe4693bb4f06f962ff552be2a69c9', // Customer in-full payment method (text): Card, Klarna, Afterpay

  // ==== Operation Booking Management Fields ====
  VC_CUSTOMER_CHANGE_FEE_PLT_CREDIT_FD_PAID = '16935b03b4760ed961905ceec4fa034059b8226c',
  VC_CUSTOMER_CHANGE_FEE_PLT_CREDIT_FD_PAID_DATE = '389fd446bca6ab403744888442031cda95337f9d',
  VC_SUPPLIER_CHANGE_FEE_PAID = 'f7bead0226a7c86c56b746dbf91ce10bf01d13fc',
  VC_SUPPLIER_CHANGE_FEE_PAID_DATE = 'ce93674037548cd9aae5cd293ee0a571a140ae3b',
  VC_PLT_CREDIT_UPDATED_PD_FIELDS = '8f46331eaf071908254355822cc7b6533f369013',
  VC_SEND_UPDATED_TRIP_CONFIRMATION = '04994d7d176f0c0a6161197edaa6371166ee6635',
  VC_QC_COMPLETE = 'c5d0290544c496335db477251c5a461939b65c3b',

  // ==== Airline Voucher Fields ====
  AIRLINE_VOUCHER_SENT_REQUEST_TO_CONVERT = '597923f69cf1ae442aa7295837bf283d0f328b4e',
  AIRLINE_VOUCHER_REDEEM_BEFORE = '8880f2eae156353adbfb567ba518620b03c64b86',
  AIRLINE_VOUCHER_EXPIRATION = '440fc9199536ba8b7948ff421cfdfbcb0097f2a9',
  AIRLINE_VOUCHER_CUSTOMER_FULLY_PAID = '49c6671c4b6a87b9ec2a49a7fcebdbb79daec618',
  AIRLINE_VOUCHER_SEND_CONFIRMATION_EMAIL = 'ebcba64888328c7f6a33399731bfbc15b7fc0055',

  AIRLINE_VOUCHER_ETICKET_NUMBERS_IN_CREDIT = 'ee20ccd14535eec776296d350d414f65f6be1c9f',
  AIRLINE_VOUCHER_AIRLINE_FEE_TO_REDEEM_PER_PERSON = 'ba17583642d30e297a0b761b54ee59c31fae6236',
  AIRLINE_VOUCHER_PLT_FEE_TO_REDEEM_PER_PERSON = '76aacfcc88aa604484ccb1d137c36ac6f4e2e2f8',
  AIRLINE_VOUCHER_ETICKET_NUMBERS = '6c46a58db5a35f60136c048b4e4ae368d6485772',
  AIRLINE_VOUCHER_AIRLINE_REFERENCE_NUMBER = 'dc136113b483afa79eb2b6f7df773edd5c0acb4e',
  AIRLINE_VOUCHER_NEW_PNR = 'b96e7ec237ac110324e743c9c37f7e8dfcc1a253',
  SUBSCRIPTION_PAUSED = 'e8379ca7017eff8e6b2851464b413184e2974231',
  TYPE_OF_GLITCH = 'a85a04d25b57d058b2e47310387790acc294e348',
  STRATEGICALLY_REBOOKED = 'dc5e72296462fe554288be56a4f0ab90d8f11504',

  CANCELLATION_REFUND_REASON = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
}

export function isMonetaryField(field: CustomFields): boolean {
  return [
    CustomFields.XL_LAY_BY_TERMINATION_FEE,
    CustomFields.XL_CUSTOMER_TOTAL_PAID_TO_DATE,
    CustomFields.VC_SUPPLIER_CHANGE_FEE_PAID,
    CustomFields.VC_CUSTOMER_CHANGE_FEE_PLT_CREDIT_FD_PAID,
    CustomFields.RF_SUPPLIER_TOTAL_CASH_REFUND,
    CustomFields.RF_AMOUNT_PROMISED_TO_CUSTOMER,
    CustomFields.REFUND_PROTECT_AMOUNT_RECEIVED,
    CustomFields.REFUND_PROTECT_POLICY_CHANGE_COST,
    CustomFields.REFUND_PROTECT_GROSS_POLICY_VALUE,
    CustomFields.AIRLINE_VOUCHER_AIRLINE_FEE_TO_REDEEM_PER_PERSON,
    CustomFields.AIRLINE_VOUCHER_PLT_FEE_TO_REDEEM_PER_PERSON,
    CustomFields.FINANCIAL_COMPENSATION,
    CustomFields.INSTALMENT_AMOUNT,
    CustomFields.CANCELATION_PENALTY,
    CustomFields.AIRLINE_COMMISSION,
    CustomFields.NET_FARE_COST,
    CustomFields.GROSS_FARE_COST,
  ].includes(field)
}

export namespace FULL_PAYMENT_MADE {
  export const YES = 108
  export const NO = 109

  export const fromBoolean = (fullPaymentMade: boolean) => (fullPaymentMade ? YES : NO)
}

export namespace PAYMENT_KIND {
  export const LAY_BY = 794
  export const PAY_IN_FULL = 795

  export type Kind = 'instalments' | 'in-full'

  export const fromKind = (kind: Kind): number | null => {
    switch (kind) {
      case 'instalments':
        return LAY_BY
      case 'in-full':
        return PAY_IN_FULL
      default:
        kind satisfies never
        return null
    }
  }

  const kinds: Record<number, Kind> = { [LAY_BY]: 'instalments', [PAY_IN_FULL]: 'in-full' }
  export const toKind = (optionId: number): Kind | null => kinds[optionId] ?? null
}

export namespace STRIPE_SUBSCRIPTION_CANCELLED {
  export const YES = 152
  export const NO = 153

  export const fromBoolean = (subscriptionCancelled: boolean) => (subscriptionCancelled ? YES : NO)
}

export const TICKETED = 'Ticketed'
export namespace TICKET_STATUS {
  const TicketStatusMapping: Record<number, string> = {
    25: TICKETED,
    26: 'Not ticketed',
  }

  export function toTicketStatus(ticketStatusId: number) {
    return TicketStatusMapping[ticketStatusId] || 'Unknown'
  }

  export function isTicketed(deal: Deal) {
    return deal.ticketStatus === TICKETED
  }
}

export namespace TICKET_SUPPLIER {
  const TicketSupplierMapping: Record<number, string> = {
    339: 'Downtown Travel',
    367: 'Express Travel Group (ETG)',
    371: 'HubFares',
    29: 'Consolidated Travel',
    151: 'Air Tickets',
    35: 'Airline Direct',
    377: 'Trippro (Mondee)',
    378: '0SQH PCC (Mondee)',
    30: 'Expedia TAAP',
    34: 'Jetstar',
    65: 'Aunt Betty',
    346: 'Expedia.com',
    365: 'BAU',
    366: 'Trip.com',
    368: 'GTG',
    369: 'Skiddoo',
    370: 'Jetaboard',
    664: 'Brightsun',
  }
  export const toTicketSupplier = (ticketSupplierId: number) => TicketSupplierMapping[ticketSupplierId] || 'Unknown'
}

export namespace PAYMENT_METHOD {
  const options: Record<number, string> = {
    137: '--Most common--',
    344: '3529 (PLT US COGS)',
    138: '3033 (PLT AU COGS)',
    177: 'Cash (Express Travel Group ETG)',
    144: 'Cash (HUBFares)',
    139: 'Cash (Consolidated Travel)',
    140: 'Cash (Air Tickets)',
    340: 'Cash (Downtown Travel)',
    379: '0SQH Cash (Mondee)',
    170: '81006 (PLT Platinum AX2)',
    354: 'Travel Bank',
    141: '--Least common--',
    164: '91001 (PLT Platinum AX1)',
    142: '38774 (PLT St George Visa)',
    167: '20453 (PLT OPEX Visa 1)',
    143: '84005 (FC Visa)',
    665: 'Cash (Brightsun)',
  }
  export const toPaymentMethod = (optionId: number) => options[optionId] || 'Unknown'
}

export namespace ITINERARY_SENT {
  const options: Record<number, string> = {
    40: 'Itinerary issued',
  }

  export const toItinerarySent = (optionId: number) => options[optionId] || 'Unknown'

  export function isSent(deal: Deal) {
    return deal.itinerarySent === toItinerarySent(40)
  }
}

export namespace ETICKET_UPLOADED {
  export enum Options {
    UPLOADED_TO_PD = 174,
    FWD_AND_LINKED_LCC = 175,
  }

  const options: Record<number, string> = {
    [Options.UPLOADED_TO_PD]: 'Yes - Uploaded ETKT to PD (without price)',
    [Options.FWD_AND_LINKED_LCC]: 'Yes - Fwd ETKT and Linked (LCC)',
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    for (const optionIdString in options) {
      if (optionIdString === value || options[optionIdString]?.toLowerCase() === lowerValue) {
        return parseInt(optionIdString, 10) as Options
      }
    }
    throw new Error('Invalid value for ETICKET_UPLOADED')
  }

  export const toEticketUploaded = (optionId: number) => options[optionId] || 'Unknown'

  // Display order for UI consumers; these labels are the wire contract parsed back by `from`.
  export const labels: readonly string[] = [Options.UPLOADED_TO_PD, Options.FWD_AND_LINKED_LCC].map(toEticketUploaded)
}

export namespace DF_FINAL_EMAIL_SENT {
  export enum Options {
    YES = 311,
    NO = 312,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }

    throw new Error('Invalid value for DF_FINAL_EMAIL_SENT')
  }
}

export namespace CONTACT_DETAILS_UPDATED_AT_FULL_PAYMENT {
  export enum Options {
    COMPLETED = 668,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'completed' || value === Options.COMPLETED.toString()) {
      return Options.COMPLETED
    }
    throw new Error('Invalid value for CONTACT_DETAILS_UPDATED_AT_FULL_PAYMENT')
  }

  export const toContactDetailsUpdatedAtFullPayment = (optionId: number): boolean => optionId === Options.COMPLETED
}

export namespace XL_STRIPE_SUBSCRIPTION_CANCELLED_AND_UNPAID_INVOICES_VOIDED {
  export enum Options {
    YES = 223,
    NO = 224,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }
    throw new Error('Invalid value for XL_STRIPE_SUBSCRIPTION_CANCELLED_AND_UNPAID_INVOICES_VOIDED')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NO]: 'No',
  }
  export const toXlStripeSubscriptionCancelled = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace XL_CANCELLED_WITH_SUPPLIER_REQUESTED_REFUND {
  export enum Options {
    YES = 293,
    NA = 320,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'n/a' || lowerValue === 'not_applicable' || value === Options.NA.toString()) {
      return Options.NA
    }
    throw new Error('Invalid value for XL_CANCELLED_WITH_SUPPLIER_REQUESTED_REFUND')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NA]: 'N/A',
  }
  export const toXlCancelledWithSupplierRequestedRefund = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace VC_QC_COMPLETE {
  export enum Options {
    YES = 276,
    NO = 277,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }
    throw new Error('Invalid value for VC_QC_COMPLETE')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NO]: 'No',
  }
  export const toVcQcComplete = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace XL_FINAL_EMAIL_SENT_TO_CUSTOMER {
  export enum Options {
    YES = 227,
    NO = 228,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }

    throw new Error('Invalid value for XL_FINAL_EMAIL_SENT_TO_CUSTOMER')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NO]: 'No',
  }
  export const toXlFinalEmailSentToCustomer = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace VC_PLT_CREDIT_UPDATED_PD_FIELDS {
  export enum Options {
    VC_YES_COMPLETED = 314,
    PLT_CREDIT_NOT_REQUIRED_METHOD_1 = 324,
    PLT_CREDIT_YES_COMPLETED_METHOD_2 = 323,
  }

  export const from = (value: string): Options => {
    const normalizedValue = value.toLowerCase().replace(/[\s\-[\].]/g, '')

    if (normalizedValue.includes('vcyescompleted') || value === Options.VC_YES_COMPLETED.toString()) {
      return Options.VC_YES_COMPLETED
    }
    if (
      normalizedValue.includes('pltcreditnotrequiredmethod1') ||
      value === Options.PLT_CREDIT_NOT_REQUIRED_METHOD_1.toString()
    ) {
      return Options.PLT_CREDIT_NOT_REQUIRED_METHOD_1
    }
    if (
      normalizedValue.includes('pltcredityescompletedmethod2') ||
      value === Options.PLT_CREDIT_YES_COMPLETED_METHOD_2.toString()
    ) {
      return Options.PLT_CREDIT_YES_COMPLETED_METHOD_2
    }

    throw new Error('Invalid value for VC_PLT_CREDIT_UPDATED_PD_FIELDS')
  }

  const optionsMapping: Record<number, string> = {
    [Options.VC_YES_COMPLETED]: 'VC Yes Completed',
    [Options.PLT_CREDIT_NOT_REQUIRED_METHOD_1]: 'PLT Credit Not Required Method 1',
    [Options.PLT_CREDIT_YES_COMPLETED_METHOD_2]: 'PLT Credit Yes Completed Method 2',
  }
  export const toVcPltCreditUpdatedPdFields = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace AIRLINE_VOUCHER_CUSTOMER_FULLY_PAID {
  export enum Options {
    YES = 325,
    NO = 326,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }
    throw new Error('Invalid value for AIRLINE_VOUCHER_CUSTOMER_FULLY_PAID')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NO]: 'No',
  }
  export const toAirlineVoucherCustomerFullyPaid = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace AIRLINE_VOUCHER_SEND_CONFIRMATION_EMAIL {
  export enum Options {
    YES_SENT = 319,
  }

  export const from = (value: string): Options => {
    const normalizedValue = value.toLowerCase().replace(/[\s-]/g, '')
    if (normalizedValue.includes('yessent') || value === Options.YES_SENT.toString()) {
      return Options.YES_SENT
    }
    throw new Error('Invalid value for AIRLINE_VOUCHER_SEND_CONFIRMATION_EMAIL')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES_SENT]: 'Yes, Sent',
  }
  export const toAirlineVoucherSendConfirmationEmail = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace VC_SEND_UPDATED_TRIP_CONFIRMATION {
  export enum Options {
    YES = 258,
    NO = 259,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (lowerValue === 'no' || lowerValue === 'false' || value === Options.NO.toString()) {
      return Options.NO
    }
    throw new Error('Invalid value for VC_SEND_UPDATED_TRIP_CONFIRMATION')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NO]: 'No',
  }
  export const toVcSendUpdatedTripConfirmation = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace RF_REMITTANCE_SENT {
  export enum Options {
    YES = 301,
    NA_NOT_REQUIRED = 321,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    if (
      lowerValue === 'n/a' ||
      lowerValue === 'not required' ||
      lowerValue === 'not_required' ||
      lowerValue === 'no customer refund.' ||
      value === Options.NA_NOT_REQUIRED.toString()
    ) {
      return Options.NA_NOT_REQUIRED
    }
    throw new Error('Invalid value for RF_REMITTANCE_SENT')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
    [Options.NA_NOT_REQUIRED]: 'N/A - not required, no customer refund.',
  }
  export const toRfRemittanceSent = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace CANCELLATION_REASON {
  const CancellationReasonMapping: Record<number, string> = {
    736: 'Within 24 hours',
    737: 'Voluntary',
    738: 'Due to involuntary airline schedule change',
    739: 'Default',
    740: 'Hardship Policy',
    741: 'Fraud related',
    742: 'PLT Credit - transferring to another booking',
    743: 'Technical Glitch',
    744: 'Previous history with PLT',
    745: 'Did not pass fraud check',
    746: 'Due to Corona Virus',
    747: 'Testing',
    762: 'Airline Insolvency',
    767: 'Non-viable booking',
    768: 'Cancelled within cooling off period',
    769: 'Pricing glitch',
    770: 'Availability glitch',
    771: 'Job Loss',
    772: 'Medical',
    773: 'Bereavement',
    774: 'Change of Mind',
    775: 'Major world event',
    776: 'Liquidation of carrier',
    777: 'Cancellation of customer event',
    778: 'No longer travelling',
    779: 'Financial Hardship',
    780: 'Customer Fraud Failure',
  }
  export const toCancellationReason = (cancellationReasonId: number) =>
    CancellationReasonMapping[cancellationReasonId] || 'Unknown'

  export const from = (value: string): number => {
    for (const [id, label] of Object.entries(CancellationReasonMapping)) {
      if (label.toLowerCase() === value.toLowerCase() || id === value) {
        return parseInt(id, 10)
      }
    }
    throw new Error(`Invalid value for CANCELLATION_REASON: ${value}`)
  }
}

export namespace SUBSCRIPTION_PAUSED {
  export enum Options {
    PAUSED_CHARGEBACK_INVESTIGATION = 594,
    PAUSED_SENSITIVE_CASE_INVESTIGATION = 599,
    RESUMED_MONITORING_REQUIRED = 596,
    RESUMED = 597,
    BOOKING_LOST = 598,
    BOOKING_LOST_EFW = 602,
    BOOKING_LOST_CHARGEBACK_RECEIVED = 603,
  }

  const optionsMapping: Record<number, string> = {
    [Options.PAUSED_CHARGEBACK_INVESTIGATION]: 'Paused - Chargeback Investigation',
    [Options.PAUSED_SENSITIVE_CASE_INVESTIGATION]: 'Paused - Sensitive Case Investigation',
    [Options.RESUMED_MONITORING_REQUIRED]: 'Resumed - Monitoring Required',
    [Options.RESUMED]: 'Resumed',
    [Options.BOOKING_LOST]: 'Booking Lost',
    [Options.BOOKING_LOST_EFW]: 'Booking Lost - EFW',
    [Options.BOOKING_LOST_CHARGEBACK_RECEIVED]: 'Booking Lost - Chargeback received',
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    // Try to match by string ID first (e.g., '594')
    for (const optionIdString in optionsMapping) {
      if (optionIdString === value) {
        return parseInt(optionIdString, 10) as Options
      }
    }

    // Try to match by human-readable label
    for (const optionIdString in optionsMapping) {
      if (optionsMapping[optionIdString]?.toLowerCase() === lowerValue) {
        return parseInt(optionIdString, 10) as Options
      }
    }

    throw new Error('Invalid value for SUBSCRIPTION_PAUSED')
  }

  export const toSubscriptionPaused = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace TYPE_OF_GLITCH {
  export enum Options {
    TICKETING_DELAY = 721,
    DELAYED_FRAUD_CHECK = 722,
    PRICE_DISCREPANCY_SHELL_PNR = 723,
    FLIGHTS_UNAVAILABLE_MANUAL_PNR = 724,
    PRICE_UNAVAILABLE_MANUAL_PNR = 725,
    PRICE_CHANGED_DURING_SYSTEM_OUTAGE = 726,
    CABIN_DISCREPANCY = 580,
    FARE_RULES = 581,
    NAME_CHANGE = 579,
    BAGGAGE_DISCREPANCY = 582,
    CODE_SHARE = 583,
    FLIGHT_AVAILABILITY = 584,
    SCHEDULE_CHANGE = 585,
    TRAVEL_DOCS_PASSPORT = 588,
    PRICE_DISCREPANCY_EXPIRED_PQ = 604,
    PRICE_DISCREPANCY_MISSED_TTL = 605,
    PRICE_DISCREPANCY_REPRICE_REQUIRED_CNN_INF = 606,
    PRICE_DISCREPANCY_MANUAL_PNR_CREATION = 607,
    PRICE_DISCREPANCY_LCC_BOOKING = 621,
    PRICE_DISCREPANCY_PLT_BOOKING_DOESNT_MATCH_PQ = 622,
    PRICE_DISCREPANCY_TTL_VALID_PRICE_INCREASED = 623,
    FARE_MISMATCH = 710,
  }

  const optionsMapping: Record<number, string> = {
    [Options.TICKETING_DELAY]: 'Ticketing Delay',
    [Options.DELAYED_FRAUD_CHECK]: 'Delayed Fraud Check',
    [Options.PRICE_DISCREPANCY_SHELL_PNR]: 'Price Discrepancy - Shell PNR',
    [Options.FLIGHTS_UNAVAILABLE_MANUAL_PNR]: 'Flights Unavailable - Manual PNR',
    [Options.PRICE_UNAVAILABLE_MANUAL_PNR]: 'Price Unavailable - Manual PNR',
    [Options.PRICE_CHANGED_DURING_SYSTEM_OUTAGE]: 'Price Changed During System Outage',
    [Options.CABIN_DISCREPANCY]: 'Cabin Discrepancy',
    [Options.FARE_RULES]: 'Fare Rules',
    [Options.NAME_CHANGE]: 'Name Change (DO NOT USE)',
    [Options.BAGGAGE_DISCREPANCY]: 'Baggage Discrepancy (DO NOT USE)',
    [Options.CODE_SHARE]: 'Code Share (DO NOT USE)',
    [Options.FLIGHT_AVAILABILITY]: 'Flight Availability (DO NOT USE)',
    [Options.SCHEDULE_CHANGE]: 'Schedule Change (DO NOT USE)',
    [Options.TRAVEL_DOCS_PASSPORT]: 'Travel docs/Passport (DO NOT USE)',
    [Options.PRICE_DISCREPANCY_EXPIRED_PQ]: 'Price Discrepancy - Expired PQ (DO NOT USE)',
    [Options.PRICE_DISCREPANCY_MISSED_TTL]: 'Price Discrepancy - Missed TTL (DO NOT USE)',
    [Options.PRICE_DISCREPANCY_REPRICE_REQUIRED_CNN_INF]:
      'Price Discrepancy - Reprice Required for CNN/INF (DO NOT USE)',
    [Options.PRICE_DISCREPANCY_MANUAL_PNR_CREATION]: 'Price Discrepancy - Manual PNR Creation (DO NOT USE)',
    [Options.PRICE_DISCREPANCY_LCC_BOOKING]: 'Price Discrepancy - LCC Booking',
    [Options.PRICE_DISCREPANCY_PLT_BOOKING_DOESNT_MATCH_PQ]:
      "Price Discrepancy - PLT Booking doesn't Match PQ (DO NOT USE)",
    [Options.PRICE_DISCREPANCY_TTL_VALID_PRICE_INCREASED]: 'Price Discrepancy - TTL Valid Price Increased (DO NOT USE)',
    [Options.FARE_MISMATCH]: 'Fare Mismatch (DO NOT USE)',
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    for (const optionIdString in optionsMapping) {
      if (optionIdString === value) {
        return parseInt(optionIdString, 10) as Options
      }
    }

    for (const optionIdString in optionsMapping) {
      if (optionsMapping[optionIdString]?.toLowerCase() === lowerValue) {
        return parseInt(optionIdString, 10) as Options
      }
    }

    throw new Error('Invalid value for TYPE_OF_GLITCH')
  }

  export const toTypeOfGlitch = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}

export namespace STRATEGICALLY_REBOOKED {
  export enum Options {
    YES = 709,
  }

  export const from = (value: string): Options => {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'yes' || lowerValue === 'true' || value === Options.YES.toString()) {
      return Options.YES
    }
    throw new Error('Invalid value for STRATEGICALLY_REBOOKED')
  }

  const optionsMapping: Record<number, string> = {
    [Options.YES]: 'Yes',
  }
  export const toStrategicallyRebooked = (optionId: number) => optionsMapping[optionId] || 'Unknown'
}
